import { GLServiceBase, ServiceRoute } from "commonui";
import { ILFSearchManager } from "./interface";
import { LFSearchReportResponseModel, LFSerachReportRequestParamsModel } from "./model";

class LFSearchServiceClass extends GLServiceBase<any, any> implements ILFSearchManager {
	serviceRoute: ServiceRoute = { prefix: "content/v1/vcsReports" };

	getLFSearchReport(params: LFSerachReportRequestParamsModel): Promise<LFSearchReportResponseModel[]> {
		return this.get("lfSearchReport", params);
	}
}

export const LFSearchManagerService = () => new LFSearchServiceClass();
